import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailmergeTableComponent } from './mailmerge-table.component';
import { TableResizerModule } from '@schoolbelle/common/table-resizer';
import { ngfModule } from 'angular-file';
import { TableModule } from '@schoolbelle/common/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MailmergeRowModule } from './mailmerge-row/mailmerge-row.module';
import { MailmergeHeaderModule } from './mailmerge-header/mailmerge-header.module';
import { MailmergeTableService } from './mailmerge-table.service';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { RowFocusBoxModule } from './row-focus-box/row-focus-box.module';


@NgModule({
  declarations: [MailmergeTableComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TableResizerModule,
    TableModule,
    ngfModule,
    TooltipModule.forRoot(),
    VirtualScrollerModule, MailmergeRowModule, MailmergeHeaderModule, RowFocusBoxModule,


  ],
  providers: [MailmergeTableService],
  exports:[
    MailmergeTableComponent,
  ],
})
export class MailmergeTableModule { 

}
